import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DoneAllAltRoundDuotone(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.2, d: "m2 14 3.233 2.425a1 1 0 0 0 1.374-.167L15 6" }), _jsx("path", { fill: "#7e869e", fillOpacity: 0.25, fillRule: "evenodd", d: "m9.951 15.33 1.902 1.52a1.6 1.6 0 0 0 2.238-.236L22.464 6.38a.6.6 0 0 0-.928-.76l-8.374 10.234a.4.4 0 0 1-.56.06l-1.89-1.514z", clipRule: "evenodd" })] }) });
}
const DoneAllAltRoundDuotone = forwardRef(_DoneAllAltRoundDuotone);
export { DoneAllAltRoundDuotone };
